import { MapPin, Phone, Instagram } from "lucide-react";
import { LogoMark } from "./Logo";
import { Reveal } from "./motion";
import { waLink, IG_LINK, ADDRESS, PHONE_1, PHONE_2, TEL_1, TEL_2, IG_HANDLE } from "./data";

const EXPLORE = [
    { label: "Collections", href: "#collections" },
    { label: "Why Us", href: "#why" },
    { label: "Visit Us", href: "#visit" },
    { label: "WhatsApp Us", href: waLink() },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-gold/15 bg-maroon-950 text-cream">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 sm:px-8 md:grid-cols-12 lg:py-20">
                <Reveal className="md:col-span-5">
                    <div className="flex items-center gap-4">
                        <LogoMark size={56} />
                        <div>
                            <p className="font-display text-lg font-bold tracking-[0.14em]">BABA GARMENTS</p>
                            <p className="font-hindi text-base text-gold/70">बाबा गारमेंट्स</p>
                        </div>
                    </div>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
                        Complete Family Fashion Store — Wholesale Specialists. Latest Trends &amp;
                        Best Quality for retailers and bulk buyers, from the heart of Kanpur.
                    </p>
                </Reveal>

                <Reveal delay={0.08} className="md:col-span-3">
                    <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-gold">Explore</p>
                    <ul className="mt-5 space-y-3">
                        {EXPLORE.map((l) => (
                            <li key={l.label}>
                                <a
                                    href={l.href}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    {...(l.href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}
                                    className="text-sm text-cream/70 transition-colors duration-300 hover:text-gold"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </Reveal>

                <Reveal delay={0.16} className="md:col-span-4">
                    <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-gold">Contact</p>
                    <ul className="mt-5 space-y-4 text-sm text-cream/70">
                        <li className="flex items-start gap-3">
                            <MapPin size={17} className="mt-0.5 shrink-0 text-gold" />
                            <span className="leading-relaxed">{ADDRESS}</span>
                        </li>
                        <li>
                            <a href={TEL_1} data-testid="footer-call-1" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                                <Phone size={17} className="shrink-0 text-gold" />
                                {PHONE_1}
                            </a>
                        </li>
                        <li>
                            <a href={TEL_2} data-testid="footer-call-2" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                                <Phone size={17} className="shrink-0 text-gold" />
                                {PHONE_2}
                            </a>
                        </li>
                        <li>
                            <a
                                href={IG_LINK}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-instagram-link"
                                className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
                            >
                                <Instagram size={17} className="shrink-0 text-gold" />
                                {IG_HANDLE}
                            </a>
                        </li>
                    </ul>
                </Reveal>
            </div>

            <div className="border-t border-gold/10">
                <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-[11px] uppercase tracking-[0.2em] text-cream/40 sm:flex-row sm:items-center sm:justify-between sm:px-8">
                    <span data-testid="footer-copyright">© {new Date().getFullYear()} Baba Garments • Cooper Ganj, Kanpur</span>
                    <span className="text-gold/60">Wholesale Only • Rates on WhatsApp</span>
                </div>
            </div>
        </footer>
    );
}